"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Buffering_1 = __importDefault(require("./Buffering"));
exports.default = Buffering_1.default;
